import {
  emailRules,
  isForeignPhoneNumberValid,
  isLandlinePhoneNumberValid,
  isMobilePhoneNumberValid
} from '../../../_common/client/helpers/validations';
import useFormFieldsCrossValidation from './useFormFieldsCrossValidation.mjs';

const useMailMobileLandlineCrossValidation = (
  form,
  getMiddleBoolean,
  countryIsFrance = true
) => {
  const mobileValidator = countryIsFrance
    ? isMobilePhoneNumberValid
    : isForeignPhoneNumberValid;
  const landlineValidator = countryIsFrance
    ? isLandlinePhoneNumberValid
    : isForeignPhoneNumberValid;

  const fieldsMetadata = {
    email: {
      formKey: 'customer.emails.0',
      errorKey: 'value',
      validatorFunction: emailRules,
      getValue: (email) => email?.value,
      baseMiddleBooleanKey: 'ADHERENT_EMAIL_EST_OBLIGATOIRE',
      crossValidationMiddleBooleanKeys: [
        'ADHERENT_TEL_MOBILE_FIXE_EMAIL_EST_OBLIGATOIRE',
        'ADHERENT_TEL_FIXE_EMAIL_EST_OBLIGATOIRE',
        'ADHERENT_TEL_MOBILE_EMAIL_EST_OBLIGATOIRE'
      ]
    },
    mobile: {
      formKey: 'customer.phones.0',
      errorKey: 'number',
      validatorFunction: mobileValidator,
      getValue: (phone) => phone?.number,
      baseMiddleBooleanKey: 'ADHERENT_TEL_MOBILE_EST_OBLIGATOIRE',
      crossValidationMiddleBooleanKeys: [
        'ADHERENT_TEL_MOBILE_FIXE_EMAIL_EST_OBLIGATOIRE',
        'ADHERENT_TEL_FIXE_MOBILE_EST_OBLIGATOIRE',
        'ADHERENT_TEL_MOBILE_EMAIL_EST_OBLIGATOIRE'
      ]
    },
    landline: {
      formKey: 'customer.phones.1',
      errorKey: 'number',
      validatorFunction: landlineValidator,
      getValue: (phone) => phone?.number,
      baseMiddleBooleanKey: 'ADHERENT_TEL_FIXE_EST_OBLIGATOIRE',
      crossValidationMiddleBooleanKeys: [
        'ADHERENT_TEL_MOBILE_FIXE_EMAIL_EST_OBLIGATOIRE',
        'ADHERENT_TEL_FIXE_MOBILE_EST_OBLIGATOIRE',
        'ADHERENT_TEL_FIXE_EMAIL_EST_OBLIGATOIRE'
      ]
    }
  };
  const getMailMobileLandlineInputRules = useFormFieldsCrossValidation(
    form,
    getMiddleBoolean,
    fieldsMetadata
  );
  return getMailMobileLandlineInputRules;
};

export default useMailMobileLandlineCrossValidation;
